// 国际机票
const internationalRouter = [
  {
    // 航班查询列表页面
    path: '/internationalIndex',
    name: 'internationalIndex',
    component: () => import('@/page/internationalFlight/internationalIndex')
  },
  {
    // 订单填写页面
    path: '/internationalOrderFill',
    name: 'internationalOrderFill',
    component: () => import('@/page/internationalFlight/internationalOrderFill'),
    meta: {
      keepAlive: false
    }
  },
  {
    // 订单确认页面
    path: '/internationalOrderConfirm',
    name: 'internationalOrderConfirm',
    component: () => import('@/page/internationalFlight/internationalOrderConfirm')
  },
  {
    // 订单预订成功页面
    path: '/intBookSuccess',
    name: 'intBookSuccess',
    component: () => import('@/page/internationalFlight/intBookSuccess')
  }
]

export default internationalRouter



// WEBPACK FOOTER //
// ./src/router/modules/international.js